import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import Sidebar from '../../components/Sidebar';
import Topbar from '../../components/Topbar';
import PageHeader from '../../components/PageHeader';
import { AIOutlineButton } from '../../components/ui/AIOutlineButton';
import { AISidebar } from '../../components/AISidebar';
import { AIRecommendationPanel } from '../../components/ai/AIRecommendationPanel';
import { getLMSCoursesRecommendations } from '../../utils/aiLMSRecommendations';
import { Search, Filter, Plus, BookOpen, MoreVertical, X, Upload, GripVertical, Trash2, Check, Star, Edit } from 'lucide-react';
// Mock data
const mockCourses = [{
  id: 1,
  title: 'Zero Waste 101',
  access: 'Gratis',
  cost: 0,
  status: 'Pubblicato',
  updatedAt: '15/05/2025',
  lessons: 5
}, {
  id: 2,
  title: 'Compostaggio Domestico',
  access: 'Star',
  cost: 500,
  status: 'Pubblicato',
  updatedAt: '10/05/2025',
  lessons: 8
}, {
  id: 3,
  title: 'Mobilità Sostenibile',
  access: 'Gratis',
  cost: 0,
  status: 'Bozza',
  updatedAt: 'Oggi',
  lessons: 3
}];
const LMSCourses = () => {
  const location = useLocation();
  const [showCreateDrawer, setShowCreateDrawer] = useState(false);
  const [showEditDrawer, setShowEditDrawer] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedCourse, setSelectedCourse] = useState<(typeof mockCourses)[0] | null>(null);
  const [openMenuId, setOpenMenuId] = useState<number | null>(null);
  const [currentStep, setCurrentStep] = useState(1);
  const [isAISidebarOpen, setIsAISidebarOpen] = useState(false);
  const recommendations = getLMSCoursesRecommendations().map(rec => ({
    ...rec,
    onCtaClick: () => console.log('CTA clicked:', rec.id)
  }));
  // Check if we should open the drawer from navigation state
  useEffect(() => {
    if (location.state?.openDrawer) {
      setCurrentStep(1);
      setShowCreateDrawer(true);
      // Clear the state
      window.history.replaceState({}, document.title);
    }
  }, [location]);
  const getStatusBadge = (status: string) => {
    switch (status) {
      case 'Pubblicato':
        return 'bg-green-100 text-green-800';
      case 'Bozza':
        return 'bg-gray-100 text-gray-800';
      default:
        return 'bg-gray-100 text-gray-800';
    }
  };
  const steps = [{
    id: 1,
    name: 'Info'
  }, {
    id: 2,
    name: 'Lezioni'
  }, {
    id: 3,
    name: 'Quiz'
  }, {
    id: 4,
    name: 'Pubblicazione'
  }];
  const handleEdit = (course: (typeof mockCourses)[0]) => {
    setSelectedCourse(course);
    setShowEditDrawer(true);
    setOpenMenuId(null);
  };
  const handleDelete = (course: (typeof mockCourses)[0]) => {
    setSelectedCourse(course);
    setShowDeleteModal(true);
    setOpenMenuId(null);
  };
  const confirmDelete = () => {
    alert(`Corso "${selectedCourse?.title}" eliminato con successo!`);
    setShowDeleteModal(false);
    setSelectedCourse(null);
  };
  const handleCreateCourse = () => {
    setCurrentStep(1);
    setShowCreateDrawer(true);
  };
  return <div className="flex h-screen bg-gray-50" data-id="element-2492">
      <div className="w-20 flex-shrink-0" data-id="element-2493">
        <Sidebar onCreateCourse={handleCreateCourse} data-id="element-2494" />
      </div>

      <div className="flex-1 flex flex-col overflow-hidden" data-id="element-2495">
        <Topbar data-id="element-2496" />
        <main className="flex-1 overflow-y-auto p-4 md:p-6" data-id="element-2497">
          {/* Page Header with AI Button */}
          <div className="mb-8" data-id="element-2498">
            <div className="flex items-start justify-between" data-id="element-2499">
              <div data-id="element-2500">
                <h1 className="text-2xl font-semibold text-gray-900" data-id="element-2501">Corsi</h1>
                <p className="text-sm font-normal text-gray-500 mt-1" data-id="element-2502">
                  Crea e gestisci corsi, lezioni e quiz
                </p>
              </div>
              <div className="flex items-center gap-3" data-id="element-2503">
                <button onClick={handleCreateCourse} className="inline-flex items-center px-4 py-2 bg-greenback text-white text-sm font-medium hover:bg-greenback/90 transition-colors" style={{
                borderRadius: '100px'
              }} data-id="element-2504">
                  <Plus className="h-4 w-4 mr-2" data-id="element-2505" />
                  Crea corso
                </button>
                <AIOutlineButton onClick={() => setIsAISidebarOpen(true)} data-id="element-2506">
                  Suggerimenti AI
                </AIOutlineButton>
              </div>
            </div>
          </div>

          {/* Filters */}
          <div className="flex gap-4 mb-6" data-id="element-2507">
            <div className="relative flex-1 max-w-md" data-id="element-2508">
              <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-gray-400" data-id="element-2509" />
              <input type="text" placeholder="Cerca corsi..." className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-600 focus:border-transparent" data-id="element-2510" />
            </div>
            <select className="border border-gray-300 rounded-lg px-4 py-2 focus:ring-2 focus:ring-green-600 focus:border-transparent" data-id="element-2511">
              <option value="" data-id="element-2512">Tutti gli stati</option>
              <option value="Pubblicato" data-id="element-2513">Pubblicato</option>
              <option value="Bozza" data-id="element-2514">Bozza</option>
            </select>
            <select className="border border-gray-300 rounded-lg px-4 py-2 focus:ring-2 focus:ring-green-600 focus:border-transparent" data-id="element-2515">
              <option value="" data-id="element-2516">Tutti gli accessi</option>
              <option value="Gratis" data-id="element-2517">Gratis</option>
              <option value="Star" data-id="element-2518">Star</option>
            </select>
          </div>

          {/* Table */}
          <div className="bg-white rounded-lg border border-gray-200 overflow-hidden" data-id="element-2519">
            <table className="w-full" data-id="element-2520">
              <thead className="bg-gray-50" data-id="element-2521">
                <tr data-id="element-2522">
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2523">
                    Corso
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2524">
                    Accesso
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2525">
                    Costo
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2526">
                    Lezioni
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2527">
                    Stato
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2528">
                    Ultimo agg.
                  </th>
                  <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2529">
                    Azioni
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200" data-id="element-2530">
                {mockCourses.map(course => <tr key={course.id} className="hover:bg-gray-50" data-id="element-2531">
                    <td className="px-6 py-4 whitespace-nowrap" data-id="element-2532">
                      <div className="flex items-center" data-id="element-2533">
                        <div className="h-10 w-10 rounded bg-gray-100 flex items-center justify-center mr-3" data-id="element-2534">
                          <BookOpen className="h-5 w-5 text-gray-500" data-id="element-2535" />
                        </div>
                        <span className="font-medium text-gray-900" data-id="element-2536">
                          {course.title}
                        </span>
                      </div>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap" data-id="element-2537">
                      <span className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${course.access === 'Gratis' ? 'bg-green-100 text-green-800' : 'bg-amber-100 text-amber-800'}`} data-id="element-2538">
                        {course.access === 'Gratis' ? 'Gratis' : 'Crediti Star'}
                      </span>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-2539">
                      {course.cost > 0 ? `${course.cost} Crediti Star` : '-'}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-2540">
                      {course.lessons}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap" data-id="element-2541">
                      <span className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${getStatusBadge(course.status)}`} data-id="element-2542">
                        {course.status}
                      </span>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-2543">
                      {course.updatedAt}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium" data-id="element-2544">
                      <div className="relative inline-block" data-id="element-2545">
                        <button onClick={e => {
                      e.stopPropagation();
                      setOpenMenuId(openMenuId === course.id ? null : course.id);
                    }} className="text-gray-400 hover:text-gray-600 p-1" data-id="element-2546">
                          <MoreVertical className="h-5 w-5" data-id="element-2547" />
                        </button>

                        {openMenuId === course.id && <>
                            <div className="fixed inset-0 z-10" onClick={() => setOpenMenuId(null)} data-id="element-2548" />
                            <div className="absolute right-0 mt-2 w-48 bg-white rounded-lg shadow-lg border border-gray-200 z-20" data-id="element-2549">
                              <button onClick={() => handleEdit(course)} className="w-full px-4 py-2 text-left text-sm hover:bg-gray-50 flex items-center gap-2 text-gray-700" data-id="element-2550">
                                <Edit className="h-4 w-4" data-id="element-2551" />
                                Modifica
                              </button>
                              <button onClick={() => handleDelete(course)} className="w-full px-4 py-2 text-left text-sm hover:bg-gray-50 flex items-center gap-2 text-red-600 border-t border-gray-100" data-id="element-2552">
                                <Trash2 className="h-4 w-4" data-id="element-2553" />
                                Elimina
                              </button>
                            </div>
                          </>}
                      </div>
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>
        </main>
      </div>

      {/* AI Sidebar */}
      <AISidebar isOpen={isAISidebarOpen} onClose={() => setIsAISidebarOpen(false)} title="Suggerimenti AI: Corsi" data-id="element-2554">
        <AIRecommendationPanel recommendations={recommendations} data-id="element-2555" />
      </AISidebar>

      {/* Create Course Drawer */}
      {showCreateDrawer && <>
          <div className="fixed inset-0 bg-black/50 backdrop-blur-sm z-40" onClick={() => setShowCreateDrawer(false)} data-id="element-2556" />
          <div className="fixed top-0 right-0 h-full w-full sm:w-[600px] bg-white shadow-2xl z-50 flex flex-col" data-id="element-2557">
            {/* Header */}
            <div className="p-6 border-b border-gray-200" data-id="element-2558">
              <div className="flex items-center justify-between mb-6" data-id="element-2559">
                <h2 className="text-xl font-bold" data-id="element-2560">Crea Nuovo Corso</h2>
                <button onClick={() => setShowCreateDrawer(false)} className="p-2 hover:bg-gray-100 rounded-full" data-id="element-2561">
                  <X className="h-5 w-5" data-id="element-2562" />
                </button>
              </div>

              {/* Stepper */}
              <div className="flex items-center justify-between px-2" data-id="element-2563">
                {steps.map((step, index) => <div key={step.id} className="flex items-center" data-id="element-2564">
                    <div className={`flex items-center justify-center w-8 h-8 rounded-full border-2 ${currentStep >= step.id ? 'border-green-600 bg-green-600 text-white' : 'border-gray-300 text-gray-500'}`} data-id="element-2565">
                      {currentStep > step.id ? <Check className="h-4 w-4" data-id="element-2566" /> : <span className="text-xs font-semibold" data-id="element-2567">{step.id}</span>}
                    </div>
                    <span className={`ml-2 text-sm font-medium ${currentStep >= step.id ? 'text-green-600' : 'text-gray-500'}`} data-id="element-2568">
                      {step.name}
                    </span>
                    {index < steps.length - 1 && <div className={`w-12 h-0.5 mx-4 ${currentStep > step.id ? 'bg-green-600' : 'bg-gray-200'}`} data-id="element-2569" />}
                  </div>)}
              </div>
            </div>

            {/* Content */}
            <div className="flex-1 overflow-y-auto p-6" data-id="element-2570">
              {currentStep === 1 && <div className="space-y-6" data-id="element-2571">
                  <div data-id="element-2572">
                    <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-2573">
                      Titolo Corso
                    </label>
                    <input type="text" className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-600 focus:border-transparent" placeholder="Es. Zero Waste 101" data-id="element-2574" />
                  </div>
                  <div data-id="element-2575">
                    <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-2576">
                      Descrizione
                    </label>
                    <textarea className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-600 focus:border-transparent" rows={4} data-id="element-2577" />
                  </div>
                  <div data-id="element-2578">
                    <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-2579">
                      Cover Image
                    </label>
                    <div className="border-2 border-dashed border-gray-300 rounded-lg p-6 text-center hover:border-green-600 transition-colors cursor-pointer" data-id="element-2580">
                      <Upload className="h-8 w-8 text-gray-400 mx-auto mb-2" data-id="element-2581" />
                      <p className="text-sm text-gray-600" data-id="element-2582">
                        Clicca per caricare l'immagine
                      </p>
                    </div>
                  </div>
                  <div data-id="element-2583">
                    <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-2584">
                      Accesso
                    </label>
                    <div className="flex gap-4" data-id="element-2585">
                      <label className="flex items-center gap-2" data-id="element-2586">
                        <input type="radio" name="access" className="text-green-600 focus:ring-green-600" defaultChecked data-id="element-2587" />
                        <span className="text-sm" data-id="element-2588">Gratis</span>
                      </label>
                      <label className="flex items-center gap-2" data-id="element-2589">
                        <input type="radio" name="access" className="text-green-600 focus:ring-green-600" data-id="element-2590" />
                        <Star className="h-4 w-4 text-amber-500" data-id="element-2591" />
                        <span className="text-sm" data-id="element-2592">
                          Sblocca con Crediti Star
                        </span>
                      </label>
                    </div>
                  </div>
                </div>}

              {currentStep === 2 && <div className="space-y-4" data-id="element-2593">
                  <div className="flex items-center justify-between mb-4" data-id="element-2594">
                    <h3 className="font-medium text-gray-900" data-id="element-2595">Lista Lezioni</h3>
                    <button className="text-sm text-green-600 font-medium hover:underline flex items-center gap-1" data-id="element-2596">
                      <Plus className="h-4 w-4" data-id="element-2597" /> Aggiungi lezione
                    </button>
                  </div>
                  {[1, 2, 3].map(i => <div key={i} className="flex items-center gap-3 p-3 bg-gray-50 rounded-lg border border-gray-200" data-id="element-2598">
                      <GripVertical className="h-5 w-5 text-gray-400 cursor-move" data-id="element-2599" />
                      <div className="flex-1" data-id="element-2600">
                        <p className="text-sm font-medium text-gray-900" data-id="element-2601">
                          Lezione {i}
                        </p>
                        <p className="text-xs text-gray-500" data-id="element-2602">Video • 5 min</p>
                      </div>
                      <button className="text-gray-400 hover:text-red-500" data-id="element-2603">
                        <Trash2 className="h-4 w-4" data-id="element-2604" />
                      </button>
                    </div>)}
                </div>}

              {currentStep === 3 && <div className="space-y-6" data-id="element-2605">
                  <div className="flex items-center justify-between mb-4" data-id="element-2606">
                    <h3 className="font-medium text-gray-900" data-id="element-2607">Domande Quiz</h3>
                    <button className="text-sm text-green-600 font-medium hover:underline flex items-center gap-1" data-id="element-2608">
                      <Plus className="h-4 w-4" data-id="element-2609" /> Aggiungi domanda
                    </button>
                  </div>
                  <div className="p-4 border border-gray-200 rounded-lg" data-id="element-2610">
                    <div className="mb-3" data-id="element-2611">
                      <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-2612">
                        Domanda 1
                      </label>
                      <input type="text" className="w-full px-3 py-2 border border-gray-300 rounded-lg" placeholder="Testo della domanda..." data-id="element-2613" />
                    </div>
                    <div className="space-y-2" data-id="element-2614">
                      <div className="flex items-center gap-2" data-id="element-2615">
                        <input type="radio" name="q1" disabled data-id="element-2616" />
                        <input type="text" className="flex-1 px-3 py-1 border border-gray-300 rounded text-sm" placeholder="Opzione A" data-id="element-2617" />
                      </div>
                      <div className="flex items-center gap-2" data-id="element-2618">
                        <input type="radio" name="q1" disabled data-id="element-2619" />
                        <input type="text" className="flex-1 px-3 py-1 border border-gray-300 rounded text-sm" placeholder="Opzione B" data-id="element-2620" />
                      </div>
                    </div>
                  </div>
                </div>}

              {currentStep === 4 && <div className="text-center py-8" data-id="element-2621">
                  <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-2622">
                    <Check className="h-8 w-8 text-green-600" data-id="element-2623" />
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-2624">
                    Tutto pronto!
                  </h3>
                  <p className="text-gray-500 mb-6" data-id="element-2625">
                    Il corso è completo e pronto per essere pubblicato.
                  </p>
                  <div className="bg-gray-50 rounded-lg p-4 text-left max-w-sm mx-auto" data-id="element-2626">
                    <p className="text-sm text-gray-600 mb-1" data-id="element-2627">
                      <span className="font-medium" data-id="element-2628">Titolo:</span> Zero Waste
                      101
                    </p>
                    <p className="text-sm text-gray-600 mb-1" data-id="element-2629">
                      <span className="font-medium" data-id="element-2630">Lezioni:</span> 3
                    </p>
                    <p className="text-sm text-gray-600" data-id="element-2631">
                      <span className="font-medium" data-id="element-2632">Quiz:</span> 1 (5 domande)
                    </p>
                  </div>
                </div>}
            </div>

            {/* Footer */}
            <div className="p-6 border-t border-gray-200 flex justify-between" data-id="element-2633">
              {currentStep > 1 ? <button onClick={() => setCurrentStep(currentStep - 1)} className="px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50" data-id="element-2634">
                  Indietro
                </button> : <button onClick={() => setShowCreateDrawer(false)} className="px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50" data-id="element-2635">
                  Annulla
                </button>}

              {currentStep < 4 ? <button onClick={() => setCurrentStep(currentStep + 1)} className="px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700" data-id="element-2636">
                  Avanti
                </button> : <button onClick={() => {
            alert('Corso pubblicato!');
            setShowCreateDrawer(false);
          }} className="px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700" data-id="element-2637">
                  Pubblica Corso
                </button>}
            </div>
          </div>
        </>}

      {/* Edit Course Drawer */}
      {showEditDrawer && selectedCourse && <>
          <div className="fixed inset-0 bg-black/50 backdrop-blur-sm z-40" onClick={() => setShowEditDrawer(false)} data-id="element-2638" />
          <div className="fixed top-0 right-0 h-full w-full sm:w-[600px] bg-white shadow-2xl z-50 overflow-y-auto" data-id="element-2639">
            <div className="p-6" data-id="element-2640">
              <div className="flex items-center justify-between mb-6" data-id="element-2641">
                <h2 className="text-xl font-bold" data-id="element-2642">Modifica Corso</h2>
                <button onClick={() => setShowEditDrawer(false)} className="p-2 hover:bg-gray-100 rounded-full" data-id="element-2643">
                  <X className="h-5 w-5" data-id="element-2644" />
                </button>
              </div>

              <div className="space-y-6" data-id="element-2645">
                <div data-id="element-2646">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-2647">
                    Titolo Corso
                  </label>
                  <input type="text" defaultValue={selectedCourse.title} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-600 focus:border-transparent" data-id="element-2648" />
                </div>
                <div data-id="element-2649">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-2650">
                    Descrizione
                  </label>
                  <textarea className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-600 focus:border-transparent" rows={4} defaultValue="Descrizione del corso..." data-id="element-2651" />
                </div>
                <div data-id="element-2652">
                  <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-2653">
                    Stato
                  </label>
                  <select defaultValue={selectedCourse.status} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-600 focus:border-transparent" data-id="element-2654">
                    <option value="Bozza" data-id="element-2655">Bozza</option>
                    <option value="Pubblicato" data-id="element-2656">Pubblicato</option>
                  </select>
                </div>
              </div>

              <div className="flex gap-3 mt-8 pt-6 border-t border-gray-200" data-id="element-2657">
                <button onClick={() => setShowEditDrawer(false)} className="flex-1 px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50" data-id="element-2658">
                  Annulla
                </button>
                <button onClick={() => {
              alert('Corso aggiornato!');
              setShowEditDrawer(false);
            }} className="flex-1 px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700" data-id="element-2659">
                  Salva modifiche
                </button>
              </div>
            </div>
          </div>
        </>}

      {/* Delete Confirmation Modal */}
      {showDeleteModal && selectedCourse && <>
          <div className="fixed inset-0 bg-black/50 backdrop-blur-sm z-40" onClick={() => setShowDeleteModal(false)} data-id="element-2660" />
          <div className="fixed inset-0 flex items-center justify-center z-50 p-4" data-id="element-2661">
            <div className="bg-white rounded-lg max-w-md w-full p-6" data-id="element-2662">
              <h3 className="text-lg font-bold text-gray-900 mb-2" data-id="element-2663">
                Elimina Corso
              </h3>
              <p className="text-gray-600 mb-6" data-id="element-2664">
                Sei sicuro di voler eliminare il corso "{selectedCourse.title}"?
                Questa azione non può essere annullata.
              </p>
              <div className="flex gap-3" data-id="element-2665">
                <button onClick={() => setShowDeleteModal(false)} className="flex-1 px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50" data-id="element-2666">
                  Annulla
                </button>
                <button onClick={confirmDelete} className="flex-1 px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700" data-id="element-2667">
                  Elimina
                </button>
              </div>
            </div>
          </div>
        </>}
    </div>;
};
export default LMSCourses;